import { addToast } from '@mobi/component-library/Feedback/Toast'
import type { ApiServiceError } from '@classic/Foundation/Services/ApiService'
import { ProblemResponse } from './api'

export function handleApiErrorNotification(err: Error) {
  if (isError(err)) {
    err.response.json().then((p: ProblemResponse) => {
      if ((p.detail || p.title) && p.requestId) {
        addToast({
          id: p.requestId,
          title: p.detail || p.title,
          icon: 'error',
          isDismissable: true,
          theme: 'dark',
        })
      }
    })
  }
}

function isError(item: object): item is ApiServiceError {
  return 'response' in item
}
